import { defineComponent as _defineComponent } from 'vue'
import ServiceList from './components/service-list/index.vue';
import { ModuleName } from '@/types/module-type';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    moduleName: null
  },
  setup(__props: any) {




return { __sfc: true,ServiceList }
}

})